import type { WhatsappTemplateCategory } from 'types/templates';

/** Programmatic marketing opt-out label (last quick-reply; Meta policy). */
export const AI_MARKETING_OPT_OUT_QUICK_REPLY_TEXT = 'הסרה מרשימת תפוצה';

/** Payload after AI + server-side marketing enrichment (JSON contract). */
export type SmartTemplateAiButtonPayload = {
  type: 'QUICK_REPLY' | 'URL';
  text: string;
  url?: string | null;
  /** Sample for URL dynamic segment when url contains {{n}} (Meta requires example). */
  url_variable_example?: string;
};

export type SmartTemplateAiPayload = {
  template_name_en: string;
  template_name_he: string;
  /** WhatsApp body; placeholders as {{1}} or single {1} (normalized before apply). */
  body_text: string;
  /**
   * Sample values for body placeholders, keyed by variable index ("1", "2", …).
   * AI should fill realistic Hebrew examples (first name, company, order id, etc.).
   */
  body_parameter_examples?: Record<string, string>;
  buttons: SmartTemplateAiButtonPayload[];
  category?: WhatsappTemplateCategory;
  /** True when a marketing opt-out quick reply was appended by the generator. */
  marketingOptOutAppended?: boolean;
};

export type GenerateSmartTemplateAiSuccess = {
  ok: true;
  payload: SmartTemplateAiPayload;
  rawText: string;
};

export type GenerateSmartTemplateAiFailure = {
  ok: false;
  error: string;
};

export type GenerateSmartTemplateAiResult = GenerateSmartTemplateAiSuccess | GenerateSmartTemplateAiFailure;

/** Compact rows for Gemini prompts — existing WABA templates (naming collisions + style). */
export type ExistingTemplateForAiContext = {
  english_name: string;
  hebrew_display_name: string;
  category: string;
  language: string;
};

export type ManualTemplateMetadataPayload = {
  template_name_en: string;
  template_name_he: string;
  category: WhatsappTemplateCategory;
  language: string;
};

export type GenerateManualMetadataSuccess = {
  ok: true;
  payload: ManualTemplateMetadataPayload;
  rawText: string;
};

export type GenerateManualMetadataFailure = {
  ok: false;
  error: string;
};

export type GenerateManualMetadataResult = GenerateManualMetadataSuccess | GenerateManualMetadataFailure;
